
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs

/**
 * Module qui gère l'affichage au survole des ouvrages par catégorie ".text-mb".
 */
export default class FF_Home_Catalogue extends FF_Module {

  /**
   * Initialise le module.
   */
  init() {

    this.elements = {
      ...this.elements,
      wrapper         : $(this.elements.container).find('.home-catalogue__wrapper').get(0),
      categories_links: $(this.elements.container).find('.home-catalogue__category-link').toArray(),
      books           : $(this.elements.container).find('.home-catalogue__book').toArray()
    };

    // En non-touch, au survol des liens des catégories, on affiche le bon ouvrage
    if (!is_touch_device) {
      $(this.elements.categories_links).on('mouseenter focus', (e) => {
        this.activate_link_book(e.currentTarget);
      });
    }

    // Sinon, on fait les ScrollTriggers qui va afficher les livres au scroll
    else {
      this.setup_scroll_triggers();
    }

    // Ajoute l'état actif au premier élément par défaut
    if (this.elements.categories_links) {
      this.activate_link_book(this.elements.categories_links[0]);
    }

  }

  /**
   * Retourne le livre associé à un lien.
   * @param {HTMLElement} link_element Élément du lien.
   * @returns {HTMLElement} Élément du livre associé.
   */
  get_link_associated_book(link_element) {
    const category_slug = $(link_element).closest('[data-category-slug]').attr('data-category-slug');
    if (!category_slug) return null;
    return this.elements.books.find((element) => $(element).attr('data-category-slug') == category_slug) || null;
  }

  /**
   * Applique l'état actif à un livre avec un lien donné.
   * @param {HTMLElement} link_element Élément du lien associé à un livre.
   */
  activate_link_book(link_element) {
    const book_element = this.get_link_associated_book(link_element);
    if (book_element && !$(book_element).hasClass('home-catalogue__book--shown')) {
      $(this.elements.container) // Retrait de l'ancien état actif
        .find('.home-catalogue__category-link--active')
        .removeClass('home-catalogue__category-link--active')
        .closest('.home-catalogue__category-link-container')
        .removeClass('home-catalogue__category-link-container--active');
      $(this.elements.container).find('.home-catalogue__book--shown').removeClass('home-catalogue__book--shown'); // **
      $(link_element)
        .addClass('home-catalogue__category-link--active')
        .closest('.home-catalogue__category-link-container')
        .addClass('home-catalogue__category-link-container--active');
      $(book_element).addClass('home-catalogue__book--shown');
    }
  }

  /**
   * Initialise les ScrollTriggers utilisés pour les appareils "touch" qui affiche/cache les livres au scroll.
   */
  setup_scroll_triggers() {
    this.elements.categories_links.forEach((link_element, link_element_i) => {
      ScrollTrigger.create({
        start      : `${((link_element_i) * 100) / (this.elements.categories_links.length)}% center`,
        end        : `${((link_element_i + 1) * 100) / (this.elements.categories_links.length)}% center`,
        trigger    : this.elements.container,
        onEnter    : () => this.activate_link_book(link_element),
        onEnterBack: () => this.activate_link_book(link_element)
      });
    });

  }
}
